export const ModeEnum = {
	ONCE: 16,
	LOOP: 0,
	LOOPREADING: 2,
	TRADE: 1,
	TRADEREADING: 3,
	CLICK: 4,
	CLICKREADING: 5,
	METRONOME: 6,
}

export const getModeName = (modeCode) => {
	for (const [key, value] of Object.entries(ModeEnum)) {
		if (value === modeCode) {
			return key
		}
	}

	return null
}

export default ModeEnum
